export function setBrandQuery() {
    const paginationButton = document.querySelector('.__endless_pagination__button[data-brand_id]');
    if(!paginationButton) return;
    const reloadedPageHref = new URL(window.location.href);
    reloadedPageHref.searchParams.set('brand_id', paginationButton.dataset.brand_id);
    history.replaceState({}, '', reloadedPageHref.search.toString());
}